<template>
  <a href="javascript:void(0)" @click.prevent="() => clickFn()">
    <div class="metadata">
      <div class="vod-series-img-wrap">
        <div class="picture-area">

          <ul class="badge-list">
            <li class="left-top-area">
              <ul v-top-tag-list="{'badgeList': topTagList(cellInfo), 'badgeType': 'artwork'}" />
            </li>
            <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList(cellInfo), 'type': 'brand'}" />
          </ul>

          <WebpImage :image-info="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: cellInfo.alt}" />
          <span v-if="hasProgressBarFrom(cellInfo)" class="progress-wrap">
            <span class="progress-bar" v-progress-bar="cellInfo.progress * 100" />
          </span>
        </div>
      </div>

      <div class="vod-series-info">
        <div class="vod-series-txt" v-title-list="{'titleList': cellInfo.title_list}" />
      </div>
    </div>

    <p class="summary" v-html="synopsis(cellInfo)" />

    <span
      v-if="hasHoldBackContentFrom(cellInfo)"
      class="badge wavve-lite"
    >
      Wavve Lite 시청 가능
    </span>
  </a>
</template>

<script>
import { commonTagList, progressBar, titleList, topTagList } from '@/common/directives'
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import WebpImage from "@/components/image/WebpImage";

export default {
  name: 'SeriesLandscapeCell',
  components: {WebpImage},
 // for vod episode
  props: {
    cellInfo: {
      type: Object,
      default: () => {}
    },
    thumbnailInfo: {
      type: Object,
      default: () => {}
    }
  },
  directives: {
    progressBar,
    titleList,
    topTagList,
    commonTagList
  },
  methods: {
    getLazyLoadObj (cell) {
      return {
        src: resizeThumbnail(cell.thumbnail, this.thumbnailInfo),
        error: this.thumbnailInfo.loadingImageUrl,
        loading: this.thumbnailInfo.loadingImageUrl
      }
    },
    clickFn () {
      this.$emit('click-fn')
    },
    topTagList (cell) {
      return get(cell, 'top_taglist', []).concat(get(cell, 'bottom_taglist', []))
    },
    brandTagList (cell) {
      return get(cell, 'brand_taglist', [])
    },
    synopsis (cell) {
      const { synopsis = '' } = cell
      return synopsis.replaceAll('<br>', ' ')
    },
    hasHoldBackContentFrom (cell) {
      const { holdbackcontent: holdBackContent = '' } = cell
      return holdBackContent.toLowerCase() === 'y'
    },
    hasProgressBarFrom (cell) {
      const { progress = '0' } = cell
      return Number(progress) > 0
    }
  }
}
</script>
